import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, unref as _unref, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, withModifiers as _withModifiers, Teleport as _Teleport, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "mv-agent-search-wrap" }
const _hoisted_2 = ["value"]
const _hoisted_3 = {
  key: 0,
  class: "mv-sheet-loading"
}
const _hoisted_4 = {
  key: 1,
  class: "mv-agent-list"
}
const _hoisted_5 = {
  key: 0,
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "#22c55e",
  "stroke-width": "3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"margin-left":"auto","flex-shrink":"0"}
}
const _hoisted_6 = ["onClick"]
const _hoisted_7 = ["src", "alt"]
const _hoisted_8 = { key: 1 }
const _hoisted_9 = {
  key: 0,
  width: "16",
  height: "16",
  viewBox: "0 0 24 24",
  fill: "none",
  stroke: "#22c55e",
  "stroke-width": "3",
  "stroke-linecap": "round",
  "stroke-linejoin": "round",
  style: {"margin-left":"auto","flex-shrink":"0"}
}

import type { AgentItem } from '@/types/chat'
import { avatarColor, initials } from '@/composables/useHelpers'


export default /*@__PURE__*/_defineComponent({
  __name: 'MobileAgentSheet',
  props: {
    open: { type: Boolean },
    agentSearch: {},
    agentLoading: { type: Boolean },
    filteredAgents: {},
    currentAssigneeId: {}
  },
  emits: ["close", "update:agentSearch", "assign"],
  setup(__props: any) {





return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_Teleport, { to: "body" }, [
    (__props.open)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "mv-sheet-overlay",
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.$emit('close')))
        }, [
          _createElementVNode("div", {
            class: "mv-sheet",
            onClick: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["stop"]))
          }, [
            _cache[10] || (_cache[10] = _createElementVNode("div", { class: "mv-sheet-handle" }, null, -1)),
            _cache[11] || (_cache[11] = _createElementVNode("div", { class: "mv-sheet-title" }, "Atribuir agente", -1)),
            _createElementVNode("div", _hoisted_1, [
              _createElementVNode("input", {
                value: __props.agentSearch,
                onInput: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('update:agentSearch', ($event.target as HTMLInputElement).value))),
                class: "mv-agent-search",
                type: "search",
                placeholder: "Buscar agente…",
                autocomplete: "off"
              }, null, 40, _hoisted_2)
            ]),
            (__props.agentLoading)
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, [...(_cache[5] || (_cache[5] = [
                  _createElementVNode("div", {
                    class: "mv-spinner",
                    style: {"width":"22px","height":"22px","border-width":"2px"}
                  }, null, -1)
                ]))]))
              : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                  _createElementVNode("button", {
                    class: "mv-agent-opt",
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$emit('assign', null)))
                  }, [
                    _cache[7] || (_cache[7] = _createElementVNode("div", {
                      class: "mv-agent-av",
                      style: {"background":"#9CA3AF","color":"#fff","font-size":"12px","font-weight":"700"}
                    }, "—", -1)),
                    _cache[8] || (_cache[8] = _createElementVNode("span", null, "Sem agente", -1)),
                    (!__props.currentAssigneeId)
                      ? (_openBlock(), _createElementBlock("svg", _hoisted_5, [...(_cache[6] || (_cache[6] = [
                          _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
                        ]))]))
                      : _createCommentVNode("", true)
                  ]),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.filteredAgents, (agent) => {
                    return (_openBlock(), _createElementBlock("button", {
                      key: agent.id,
                      class: "mv-agent-opt",
                      onClick: ($event: any) => (_ctx.$emit('assign', agent.id))
                    }, [
                      _createElementVNode("div", {
                        class: "mv-agent-av",
                        style: _normalizeStyle({ background: _unref(avatarColor)(agent.name) })
                      }, [
                        (agent.thumbnail)
                          ? (_openBlock(), _createElementBlock("img", {
                              key: 0,
                              src: agent.thumbnail,
                              alt: agent.name,
                              onError: _cache[2] || (_cache[2] = (e) => (e.target as HTMLImageElement).style.display='none')
                            }, null, 40, _hoisted_7))
                          : (_openBlock(), _createElementBlock("span", _hoisted_8, _toDisplayString(_unref(initials)(agent.name)), 1))
                      ], 4),
                      _createElementVNode("span", null, _toDisplayString(agent.name), 1),
                      (__props.currentAssigneeId === agent.id)
                        ? (_openBlock(), _createElementBlock("svg", _hoisted_9, [...(_cache[9] || (_cache[9] = [
                            _createElementVNode("polyline", { points: "20 6 9 17 4 12" }, null, -1)
                          ]))]))
                        : _createCommentVNode("", true)
                    ], 8, _hoisted_6))
                  }), 128))
                ]))
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})